import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const OrderDetailProductSkeleton = () => {
  return (
    <div className="col-md-8 col-lg-8">
      <div className="cart-added-products" style={{ opacity: 1 }}>
        {/* Skeleton for Image */}
        <div className="added-cartPro-img">
          <Skeleton height={100} width={100} />
        </div>

        {/* Skeleton for Content */}
        <div className="added-cartPro-content">
          {/* Skeleton for Info */}
          <div className="added-cartPro-info">
            <div className="added-cartPro-item">
              <h6>
                <Skeleton width={150} />
              </h6>
              <p>
                <Skeleton width={200} />
              </p>
            </div>

            {/* Skeleton for Buttons */}
            <div className="cart-remove-wishlist">
              <Skeleton circle={true} height={40} width={40} />
              <Skeleton circle={true} height={40} width={40} />
            </div>
          </div>

          {/* Skeleton for Price and Quantity */}
          <div className="added-cartPro-price">
            <Skeleton width={50} />
            <div className="product-quantity">
              <div className="qty-container">
                <Skeleton height={40} width={40} />
                <Skeleton height={40} width={60} />
                <Skeleton height={40} width={40} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
